<template>
  <div id="app">
    <div id="scene">
      <canvas id="scene-image" ref="sceneImg" :style="'transform: ' + backgroundTransform" />
      <div id="white-filter" />
      <div id="black-filter" />
    </div>

    <div id="menu">
      <router-link @click.native="playSound" to="/home" class="item" :class="{ 'active': $route.params.page === 'home' }">Home</router-link>
      <router-link @click.native="playSound" to="/guns" class="item" :class="{ 'active': $route.params.page === 'guns' }">Guns</router-link>
      <router-link @click.native="playSound" to="/ranks" class="item" :class="{ 'active': $route.params.page === 'ranks' }">Ranks</router-link>
      <router-link @click.native="playSound" to="/rank-upgrades" class="item" :class="{ 'active': $route.params.page === 'rank-upgrades' }">Rank upgrades</router-link>
      <router-link @click.native="playSound" to="/specials" class="item" :class="{ 'active': $route.params.page === 'specials' }">Specials</router-link>
      <router-link @click.native="playSound" to="/limited" class="item" :class="{ 'active': $route.params.page === 'limited' }">Limited</router-link>
    </div>

    <div id="pages">
      <transition :name="transitionName" show appear>
        <keep-alive max="5">
          <router-view :key="JSON.stringify($route.params)"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import { Howl } from 'howler'
import * as StackBlur from 'stackblur-canvas'

export default {
  data () {
    return {
      houseIcon: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m498.195312 222.695312c-.011718-.011718-.023437-.023437-.035156-.035156l-208.855468-208.847656c-8.902344-8.90625-20.738282-13.8125-33.328126-13.8125-12.589843 0-24.425781 4.902344-33.332031 13.808594l-208.746093 208.742187c-.070313.070313-.140626.144531-.210938.214844-18.28125 18.386719-18.25 48.21875.089844 66.558594 8.378906 8.382812 19.445312 13.238281 31.277344 13.746093.480468.046876.964843.070313 1.453124.070313h8.324219v153.699219c0 30.414062 24.746094 55.160156 55.167969 55.160156h81.710938c8.28125 0 15-6.714844 15-15v-120.5c0-13.878906 11.289062-25.167969 25.167968-25.167969h48.195313c13.878906 0 25.167969 11.289063 25.167969 25.167969v120.5c0 8.285156 6.714843 15 15 15h81.710937c30.421875 0 55.167969-24.746094 55.167969-55.160156v-153.699219h7.71875c12.585937 0 24.421875-4.902344 33.332031-13.808594 18.359375-18.371093 18.367187-48.253906.023437-66.636719zm0 0"/></svg>',
      sparklesIcon: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m497 353.671875c-30.4375 0-59.023438-11.742187-80.5-33.066406-21.46875-21.3125-33.289062-49.699219-33.289062-79.929688 0-8.285156-6.71875-15-15-15-8.285157 0-15 6.714844-15 15 0 30.230469-11.824219 58.617188-33.292969 79.929688-21.476563 21.324219-50.0625 33.066406-80.5 33.066406-8.285157 0-15 6.714844-15 15s6.714843 15 15 15c62.742187 0 113.792969 50.839844 113.792969 113.328125 0 8.285156 6.714843 15 15 15 8.28125 0 15-6.714844 15-15 0-62.488281 51.046874-113.328125 113.789062-113.328125 8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"/><path d="m205.234375 236.386719c-44.175781 0-80.117187-35.675781-80.117187-79.53125 0-8.28125-6.714844-15-15-15-8.285157 0-15 6.71875-15 15 0 43.855469-35.941407 79.53125-80.117188 79.53125-8.285156 0-15 6.71875-15 15 0 8.285156 6.714844 15 15 15 44.175781 0 80.117188 35.789062 80.117188 79.777343 0 8.28125 6.714843 15 15 15 8.285156 0 15-6.71875 15-15 0-43.988281 35.941406-79.777343 80.117187-79.777343 8.285156 0 15-6.714844 15-15 0-8.28125-6.714844-15-15-15zm0 0"/><path d="m229.636719 103.65625c32.488281 0 58.921875 26.230469 58.921875 58.46875 0 8.28125 6.714844 15 15 15s15-6.71875 15-15c0-32.34375 26.433594-58.65625 58.921875-58.65625 8.285156 0 15-6.71875 15-15 0-8.285156-6.714844-15-15-15-32.488281 0-58.921875-26.230469-58.921875-58.46875 0-8.285156-6.714844-15-15-15s-15 6.714844-15 15c0 32.34375-26.433594 58.65625-58.921875 58.65625-8.285157 0-15 6.714844-15 15s6.714843 15 15 15zm0 0"/></svg>',
      userIcon: '<svg id="Capa_1" enable-background="new 0 0 515.556 515.556" viewBox="0 0 515.556 515.556" xmlns="http://www.w3.org/2000/svg"><path d="m348.918 37.751c50.334 50.334 50.334 131.942 0 182.276s-131.942 50.334-182.276 0-50.334-131.942 0-182.276c50.334-50.335 131.942-50.335 182.276 0"/><path d="m455.486 350.669c-117.498-79.391-277.917-79.391-395.415 0-17.433 11.769-27.848 31.656-27.848 53.211v111.676h451.111v-111.676c0-21.555-10.416-41.442-27.848-53.211z"/></svg>',
      mailIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M339.392 258.624L512 367.744V144.896zM0 144.896v222.848l172.608-109.12zM480 80H32C16.032 80 3.36 91.904.96 107.232L256 275.264l255.04-168.032C508.64 91.904 495.968 80 480 80zM310.08 277.952l-45.28 29.824a15.983 15.983 0 01-8.8 2.624c-3.072 0-6.112-.864-8.8-2.624l-45.28-29.856L1.024 404.992C3.488 420.192 16.096 432 32 432h448c15.904 0 28.512-11.808 30.976-27.008L310.08 277.952z"/></svg>',
      playIcon: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 477.867 477.867" style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve"><g><g><path d="M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933C477.726,107.033,370.834,0.141,238.933,0z M339.557,246.546c-1.654,3.318-4.343,6.008-7.662,7.662v0.085L195.362,322.56c-8.432,4.213-18.682,0.794-22.896-7.638c-1.198-2.397-1.815-5.043-1.8-7.722V170.667c-0.004-9.426,7.633-17.07,17.059-17.075c2.651-0.001,5.266,0.615,7.637,1.8l136.533,68.267C340.331,227.863,343.762,238.11,339.557,246.546z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',
      sceneWidth: 0,
      sceneHeight: 0,
      pointerX: 0,
      pointerY: 0,
      transitionName: 'to-bottom'
    }
  },
  computed: {
    backgroundTransform () {
      const e = this.$store.state.pointerPos

      const maxScreenX = window.innerWidth
      const maxScreenY = window.innerHeight

      const modifier = 20

      return `scale(1.055) translate3d(${(e.x / modifier) - ((maxScreenX / modifier) / 2)}px, ${(e.y / modifier) - (maxScreenY / modifier) / 2}px, 0)`
    },
    overlayTransform () {
      const e = this.$store.state.pointerPos

      const maxScreenX = window.innerWidth
      const maxScreenY = window.innerHeight

      const modifier = 80

      return `translate3d(${(e.x / modifier) - ((maxScreenX / modifier) / 2)}px, ${(e.y / modifier) - (maxScreenY / modifier) / 2}px, 0)`
    }
  },
  methods: {
    playSound () {
      const sound = new Howl({
        src: ['./audio/browse_menu_various_47.mp3'],
        autoplay: true,
        loop: false,
        volume: 1
      })
    },
    handleMouseMove (e) {
      // this.pointerX = e.x
      // this.pointerY = e.y

      this.$store.commit('setPos', { x: window.innerWidth - e.x, y: window.innerHeight - e.y })
    },
    getComputedTranslate (axis, obj) {
      const style = getComputedStyle(obj)
      const transform = style.transform || style.webkitTransform || style.mozTransform
      let mat = transform.match(/^matrix3d\((.+)\)$/)
      if (mat) return parseFloat(mat[1].split(', ')[13])
      mat = transform.match(/^matrix\((.+)\)$/)
      return mat ? parseFloat(mat[1].split(', ')[axis === 'y' ? 5 : 4]) : 0
    },
    blurScene (doBlur) {
      if (doBlur) {
        StackBlur.image(this.sceneImage, this.$refs.sceneImg, 50)
      } else {
        StackBlur.image(this.sceneImage, this.$refs.sceneImg)
      }
    }
  },
  mounted () {
    const sound = new Howl({
      src: ['./audio/PM_BP_120_05.wav'],
      autoplay: true,
      loop: true,
      volume: 0.5
    })

    const bg = new Image()

    bg.onload = e => {
      console.log(bg.width)

      StackBlur.image(bg, this.$refs.sceneImg)
      this.blurScene(true)
    }

    bg.crossOrigin = 'Anonymous'

    bg.src = '/img/minecraft-shader-wallpaper-preview.jpg'
    // bg.src = '/img/wallpaper-minecraft-alt-1.jpg'
    // bg.src = '/img/DNAZRBA.png'

    this.sceneImage = bg
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'Product' || from.name === 'Product') {
        this.transitionName = 'to-bottom'
      } else {
        const pages = ['home', 'guns', 'ranks', 'rank-upgrades', 'specials', 'limited']
        this.transitionName = pages.indexOf(to.params.page) < pages.indexOf(from.params.page) ? 'to-left' : 'to-right'
      }
    }
  },
  created () {
    window.addEventListener('mousemove', this.handleMouseMove)
  },
  destroyed () {
    window.removeEventListener('mousemove', this.handleMouseMove)
  }
}
</script>

<style lang="scss">
@mixin font($font-family, $font-file) {
  @font-face {
    font-family: $font-family;
    src: url($font-file+'.eot');
    src: url($font-file+'.eot?#iefix') format('embedded-opentype'),
         url($font-file+'.woff') format('woff'),
         url($font-file+'.ttf') format('truetype'),
         url($font-file+'.svg#aller') format('svg');
    font-weight: normal;
    font-style: normal;
  }
}


@include font('Rift-Bold', '/fonts/Rift-Bold/Rift-Bold');
@include font('Rift-BoldItalic', '/fonts/Rift-BoldItalic/Rift-BoldItalic');
@include font('Rift-Demi', '/fonts/Rift-Demi/Rift-Demi');
@include font('Rift-DemiItalic', '/fonts/Rift-DemiItalic/Rift-DemiItalic');
@include font('Rift-Medium', '/fonts/Rift-Medium/Rift-Medium');
@include font('Rift-MediumItalic', '/fonts/Rift-MediumItalic/Rift-MediumItalic');
@include font('Rift-Regular', '/fonts/Rift-Regular/Rift-Regular');
@include font('Rift-RegularItalic', '/fonts/Rift-RegularItalic/Rift-RegularItalic');
@include font('Rift-Light', '/fonts/Rift-Light/Rift-Light');
@include font('Rift-LightItalic', '/fonts/Rift-LightItalic/Rift-LightItalic');

#app {
  font-family: Rift-Demi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 600;
  letter-spacing: 0.5px;
  // line-height: 1em;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100vh;

  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  #scene {
    z-index: -1;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 25vh;
      background: linear-gradient(0deg, rgba(#000, 0) 0%, rgba(#000, .5) 100%);
      // background: red;
    }

    #scene-image {
      min-width: 100%;
      max-width: 100vh;
      min-height: 100vh;
      max-height: 100vh;
      background-color: #000;
      object-fit: cover;
      transform-style: flat;
      backface-visibility: hidden;
      perspective: 1000;
      will-change: transform;
    }

    #white-filter {
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#ECECF5, .15);
    }

    #black-filter {
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#000, .15);
    }
  }

  #menu {
    width: 100%;
    max-width: 1200px;
    margin: 30px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .item {
      font-size: 24px;
      padding: 15px 30px;
      font-weight: 600;
      color: rgba(#fff, .33);
      font-style: italic;

      &.active {
        font-weight: 700;
        color: #fff;
      }
    }
  }

  #pages {
    position: relative;
    min-height: 100vh;
    width: 100%;
    max-width: 1200px;
    display: flex;
  }
}

a {
  text-decoration: none;
  color: inherit;
}

// ::selection {
//   background-color: rgba(#000, 0.99); // NOTE: #000 isn't truely black on chromium
//   color: #fff;
// }

::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(#fff, .15);
  border: 6px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;

  &:hover {
    border-width: 4px;
    background-color: rgba(#fff, .33);
  }
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
}

::-webkit-scrollbar-corner {
    background-color: transparent;
}

body {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  font-weight: 600;
  overflow: overlay;
  // letter-spacing: 1px;
  // line-height: 1em;
  scroll-behavior: smooth;
  // text-rendering: optimizeSpeed !important;
  text-rendering: geometricPrecision !important;
  overflow-x: hidden;
}

.to-left-enter-active,
.to-left-leave-active {
  animation-duration: 0.3s;
  // animation-fill-mode: both;
  animation-timing-function: ease-out;
  animation-name: to-left-in;
}

.to-left-leave-active {
  // animation-direction: reverse;
  animation-name: to-right-out;
}

.to-right-enter-active,
.to-right-leave-active {
  animation-duration: 0.3s;
  // animation-fill-mode: both;
  animation-timing-function: ease-out;
  animation-name: to-right-in;
}

.to-right-leave-active {
  // animation-direction: reverse;
  animation-name: to-left-out;
}

.to-bottom-enter-active,
.to-bottom-leave-active {
  animation-duration: 0.3s;
  // animation-fill-mode: both;
  animation-timing-function: ease-out;
  animation-name: to-bottom-in;
}

.to-bottom-leave-active {
  // animation-direction: reverse;
  animation-name: to-bottom-out;
}

@keyframes to-left-in {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes to-left-out {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes to-right-in {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes to-right-out {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes to-bottom-in {
  0% {
    opacity: 0;
    transform: translate3d(0, 100vh, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes to-bottom-out {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 100vh, 0);
  }
}
</style>
